import React from 'react';

import ProjectAddDialog from 'containers/pages/projects/ProjectAddDialog';
import DeleteProjectDialog from 'containers/pages/projects/DeleteDialog';
import EditNameDialog from 'containers/pages/projects/EditNameDialog';
import TaskSchedulerDialog from 'containers/structural/TaskSchedulerDialog';
import StatusSheet from 'components/common/StatusSheet';
import ResetScrollUponNav from 'components/structural/ResetScrollUponNav';
import Dialogs from 'components/common/Dialogs';
import GlobalStyles from 'components/styles/GlobalStyles';

const GlobalComponents = () => {
	return (
		<>
			<GlobalStyles />
			<Dialogs />
			<ResetScrollUponNav />
			<ProjectAddDialog />
			<DeleteProjectDialog />
			<EditNameDialog />
			<TaskSchedulerDialog />
			<StatusSheet />
		</>
	);
};

export default GlobalComponents;
